import isOutOfStock from './isOutOfStok';

const isBackOrder = (
  // eslint-disable-next-line camelcase
  { allow_backorder, unlimited, quantity },
// eslint-disable-next-line camelcase
) => isOutOfStock({ unlimited, quantity }) && allow_backorder;

export default isBackOrder;
